import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, TableCell, TableRow, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
import CustomTable from "../../../core/components/common/custom-table.component";
import CustomClickableLabel from "../../../core/components/ui/custom-clickable-label.component";
import CustomeStatusLabel from '../../../core/components/ui/custom-status-label.component'
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UpdateIcon from "@mui/icons-material/Update";
import theme from "../../../core/components/layout/theme";
import UpdateStatusDialog from "./update-status.dialog";
import { permissions } from "../../../core/components/common/variables/static_variables";
import { useGuard } from "../../RBACPlugin";

import UpdateDeviceDialog from "./update-device.dialog";
import UpdateEntryTypeDialog from "./update-entry-type.dialog";
import ViewDeviceComponent from "./view-device.component";
import DevicesIcon from '@mui/icons-material/Devices';
import KeyIcon from '@mui/icons-material/Key';
import VisibilityIcon from '@mui/icons-material/Visibility';


const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedDevice, setOpen, theme, customIconStyles, onAction, handleViewDetails} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const navigate = useNavigate();
    const {hasPermission} = useGuard();

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleUpdateStatus = () => {
        setOpen(true);
        setSelectedDevice(data)
    }

    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}}  />,
            label: "View Device",
            onClick: () => handleViewDetails(data),
            requiredPermission: permissions.deviceManagement.VIEW_DEVICE,
        },
        {
            icon: <DevicesIcon fontSize="small" sx={{ color: "green", fontSize: 23 }} />,
            label: "Update Device",
            onClick: () => onAction("device", data),
            // requiredPermission: permissions.deviceManagement.UPDATE_DEVICE,
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{ color: theme.palette.primary.main, fontSize: 23 }} />,
            label: "Update Status",
            requiredPermission: permissions.deviceManagement.UPDATE_STATUS_DEVICE,
            onClick: (e) => onAction("status", data)
        },
        {
            icon: <KeyIcon fontSize="small" sx={{ color: "orange", fontSize: 23 }} />,
            label: "Update Entry",
            onClick: () => onAction("entry_type", data),
            requiredPermission: permissions.deviceManagement.UPDATE_ENTRY_TYPE_DEVICE,
        }
    ].filter((item) => hasPermission(item.requiredPermission))

    return (
        <>
  
            {
                menuItems.length > 0 &&
                <>
                    <IconButton onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{style: {maxHeight: 300}}}
                    >
                        {menuItems?.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    handleClose();
                                    item.onClick();
                                }}
                                sx={{}}
                            >
                                <ListItemIcon sx={customIconStyles}>
                                    {item.icon}
                                </ListItemIcon>
                    
                                <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            }
        </>
    );
};


export default function DeviceManagementListComponent (props) {

    const { list, viewDeviceDetails, setViewDeviceDetails } = props;
    const [dialog, setDialog] = useState({ open: false, type: null, device: null });
    

    const [data, setData] = useState(null);

    const openDialog = (type, device) => {
        setDialog({ open: true, type, device });
    };

    const closeDialog = () => {
        setDialog({ open: false, type: null, device: null });
    };

    const handleViewDetails = (row) => {
        console.log('rowwwwwww', row)
        setViewDeviceDetails(true)
        setData(row)
    }

    const headers = [
        { label: "Device ID" },
        { label: "Model" },
        { label: "Manufacturer" },
        { label: "OS Version" },
        { label: "Status" },
        { label: "Entry Type" },
        { label: "Actions" }
    ];

    return (
        <Box sx={{ mt: 2 }}>
            {!viewDeviceDetails ? 
            
            <CustomTable headers={headers}>
                {list?.content?.length > 0 ? (
                    list?.content.map((row) => (
                        <>
                        <TableRow key={row.id}>
                            <TableCell onClick={() => handleViewDetails(row)}><CustomClickableLabel>{row.device_id}</CustomClickableLabel></TableCell>
                            <TableCell onClick={() => handleViewDetails(row)}><CustomClickableLabel>{row.model}</CustomClickableLabel></TableCell>
                            <TableCell>{row.manufacturer}</TableCell>
                            <TableCell>{row.os_version}</TableCell>
                            <TableCell>
                                <CustomChipComponent category="deviceStatusStyles"
                                    label={
                                        row.status === "Active" ? "Active" :
                                        (row.status === "Deactivated" || row.status === "Deactivate") ? "Deactivated" :
                                        row.status === "Pending" ? "Pending" :
                                        row.status
                                    }
                                />
                            </TableCell>
                            <TableCell>{row.entry_type || "N/A"}</TableCell>
                            <TableCell>
                                <CustomMenuPopperComponent
                                    data={row}
                                    onAction={openDialog}
                                    theme={theme}
                                    handleViewDetails={handleViewDetails}
                                />
                            </TableCell>
                        </TableRow>
                        </>
                    ))
                ) : (
                    <TableRow>
                        <TableCell colSpan={headers.length} align="center">
                            No available device to display
                        </TableCell>
                    </TableRow>
                )}
            </CustomTable>
            :
                <ViewDeviceComponent data={data} setViewDeviceDetails={setViewDeviceDetails}/>
            }

            {dialog.open && dialog.type === "status" && (
                <UpdateStatusDialog
                    open={dialog.open}
                    setOpen={closeDialog}
                    selectedDevice={dialog.device}
                />
            )}

            {dialog.open && dialog.type === "device" && (
                <UpdateDeviceDialog
                    open={dialog.open}
                    setOpen={closeDialog}
                    selectedDevice={dialog.device}
                />
            )}
            {dialog.open && dialog.type === "entry_type" && (
                <UpdateEntryTypeDialog
                    open={dialog.open}
                    setOpen={closeDialog}
                    selectedDevice={dialog.device}
                />
            )}
        </Box>
    );
}